module.exports = __webpack_public_path__ + "media/honey-icons/icon-battery-three-quarters-4e2d0294.svg";